class Accordion {
  init() {
    this.containerClass = '.js-accordion';
    this.triggerClass = '.js-accordion-trigger';
    this.action = 'click';
    this.container = document.querySelectorAll(this.containerClass);

    if(!this.container) return null;

    this.container.forEach(element => {
      this.bindEvents(element)
    });
  }

  bindEvents(element) {
    const _this = this;
    element.querySelectorAll(this.triggerClass).forEach(trigger => {
      trigger.addEventListener(_this.action, _this.toggleItem, false);
    })
  }

  toggleItem() {
    if(this.parentNode.classList.contains('active')) {
      this.parentNode.classList.remove('active')
    } else {
      this.parentNode.classList.add('active')
    }
  }
}

export default Accordion;
